"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7596],{

/***/ 28977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _s4l_stayforlong_property_ListOfPriceDistribution__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80762);
/* harmony import */ var _s4l_stayforlong_property_SearchFilters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61356);
/* harmony import */ var _s4l_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9947);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94449);
/* harmony import */ var src_effects_Properties_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82598);
/* harmony import */ var _FiltersContainer_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16190);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_hooks_useKafkaEvent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96128);
/* harmony import */ var src_hooks_useKafkaEvent_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18935);












var Filters = function(param) {
    var onSubmit = param.onSubmit;
    var handleApplyFilters = function handleApplyFilters(newFilters) {
        setFilters(function(prev) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prev, newFilters);
        });
    };
    var onSubmitInternal = function onSubmitInternal(newFilters) {
        handleApplyFilters(newFilters);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(newFilters);
    };
    var ref;
    var distributionPriceRange = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(src_effects_Properties_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getDistributionPriceRange */ .SR);
    var isFetching = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(src_effects_Properties_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getIsFetching */ .ab);
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)().query;
    var hasExtendedFilters = (ref = query.ff) === null || ref === void 0 ? void 0 : ref.includes("new_filters");
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_FiltersContainer_context__WEBPACK_IMPORTED_MODULE_7__/* .FiltersContext */ .o), filters = ref1.filters, setFilters = ref1.setFilters;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoadingPriceDistribution = ref2[0], setIsLoadingPriceDistribution = ref2[1];
    var ref3 = (0,src_hooks_useKafkaEvent__WEBPACK_IMPORTED_MODULE_9__/* .useKafkaEvent */ .L)({
        page: src_hooks_useKafkaEvent_constants__WEBPACK_IMPORTED_MODULE_10__/* .PAGES.LIST */ .q5.LIST,
        eventName: "filters_bottom_sheet_closed"
    }), sendFiltersBottomSheetClosed = ref3.sendEvent;
    var onBottomSheetClosed = function() {
        sendFiltersBottomSheetClosed({
            section: src_hooks_useKafkaEvent_constants__WEBPACK_IMPORTED_MODULE_10__/* .SECTIONS.SEARCH_FILTERS */ .SA.SEARCH_FILTERS
        });
    };
    var filtersModel = _s4l_stayforlong_property_SearchFilters__WEBPACK_IMPORTED_MODULE_3__/* .SearchFilters.fromPrimitives */ .J.fromPrimitives(filters);
    var listOfPriceDistributionModel = _s4l_stayforlong_property_ListOfPriceDistribution__WEBPACK_IMPORTED_MODULE_2__/* .ListOfPriceDistribution.fromLegacyContext */ .z.fromLegacyContext(distributionPriceRange);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isLoadingPriceDistribution) return;
        setIsLoadingPriceDistribution(isFetching);
    }, [
        isFetching,
        isLoadingPriceDistribution
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_s4l_uikit__WEBPACK_IMPORTED_MODULE_4__.SearchFilters, {
        isLoadingPriceDistribution: isLoadingPriceDistribution,
        onFilterChange: handleApplyFilters,
        onSubmit: onSubmitInternal,
        defaultFiltersJSON: filtersModel.toJSON(),
        listOfPriceDistributionJSON: listOfPriceDistributionModel.toJSON(),
        showExtendedFilters: hasExtendedFilters,
        onBottomSheetClosed: onBottomSheetClosed
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Filters);


/***/ })

}]);